module.exports = __webpack_public_path__ + "img/amrei_11_done_3_auto_x2_minified.0c2da055.jpeg";